import utransferV2API from "./utransferV2";

export const createDeviceDriver = async (customerId, deviceId, driverId) => {
  const response = await utransferV2API.post(
    `/customers/${customerId}/devices/${deviceId}/drivers/${driverId}`
  );
  return response.data;
};
